export default __webpack_public_path__ + "static/media/phone-icon.f57b91b8.svg";